import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
    const { user, loading } = useAuth();

    // Show loading while checking authentication status
    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
    }

    // If a user object exists, the user is authenticated.
    return user ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
